<template>
    <div class="px-3 mt-2">
       <div>
           <btable/>
       </div>
    </div>
</template>
<script>
import btable from '@/components/BillingTable'
export default {
    components:{
        btable
    },
}
</script>
<style>
    
</style>

